import { useEffect, useState } from 'react';
import { useEmployee } from './EmployeeContext';
import { employeeApi } from '../../lib/api';
import { pushSupported, pushPermission, subscribeToPush } from '../../lib/push';
import { errorMessage } from '../../components/ErrorModalBody';
import { AlterarPinForm } from './AlterarPinForm';

export function ContaTab() {
  const { employee, signature, documentPhoto, profilePhotoUrl } = useEmployee();
  const [notifStatus, setNotifStatus] = useState<string>('unsupported');
  const [notifBusy, setNotifBusy] = useState(false);
  const [notifError, setNotifError] = useState('');
  const [trocandoPin, setTrocandoPin] = useState(false);

  useEffect(() => { setNotifStatus(pushPermission()); }, []);

  async function ativarNotificacoes() {
    setNotifBusy(true);
    setNotifError('');
    try {
      const sub = await subscribeToPush();
      await employeeApi.savePushSubscription(sub);
      setNotifStatus('granted');
    } catch (err) {
      setNotifError(errorMessage(err));
    } finally {
      setNotifBusy(false);
    }
  }

  return (
    <>
      <div className="card" style={{ textAlign: 'center' }}>
        {profilePhotoUrl ? (
          <img src={profilePhotoUrl} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: '50%', border: '3px solid var(--pink)' }} />
        ) : (
          <div style={{ width: 120, height: 120, borderRadius: '50%', background: 'var(--surface-soft)', border: '1px solid var(--line)', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ink-soft)', fontSize: 12, textAlign: 'center', padding: 8 }}>Ainda sem selfie registrada</div>
        )}
        <h2 style={{ marginTop: 14, marginBottom: 2 }}>{employee.nome}</h2>
        <p className="muted">{employee.funcao} · {employee.camarote}</p>
        <p className="hint" style={{ marginTop: 8 }}>Sua foto de perfil é a selfie mais recente de um dos seus registros (ponto, alimentação ou recebimento) — não dá pra trocar manualmente.</p>
      </div>

      {pushSupported() && notifStatus !== 'granted' && (
        <div className="card">
          <h2>Ativar notificações</h2>
          <p className="hint">Receba avisos e lembretes do gestor direto no seu navegador. Vai aparecer um pedido de permissão — toque em "Permitir".</p>
          {notifError && <div className="err">{notifError}</div>}
          <button className="btn btn-primary btn-block" disabled={notifBusy} onClick={ativarNotificacoes}>Ativar notificações</button>
        </div>
      )}
      {notifStatus === 'granted' && (
        <div className="card"><div className="pill pill-ok">✓ Notificações ativadas</div></div>
      )}

      <div className="card">
        <h2>Minha senha</h2>
        {trocandoPin ? (
          <>
            <AlterarPinForm onDone={() => setTrocandoPin(false)} />
            <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={() => setTrocandoPin(false)}>Cancelar</button>
          </>
        ) : (
          <>
            <p className="hint">Use o telefone completo + essa senha (PIN de 4 dígitos) pra entrar.</p>
            <button className="btn btn-ghost btn-block" onClick={() => setTrocandoPin(true)}>Trocar minha senha</button>
          </>
        )}
      </div>
      <div className="card">
        <h2>Meus dados</h2>
        <div className="kv"><span>CPF</span><span>{employee.cpf || '—'}</span></div>
        <div className="kv"><span>PIS</span><span>{employee.pis || '—'}</span></div>
        <div className="kv"><span>Telefone</span><span>{employee.telefone || '—'}</span></div>
        <div className="kv"><span>PIX</span><span>{employee.pix || '—'}</span></div>
        <div className="kv"><span>Endereço</span><span>{employee.endereco || '—'}</span></div>
        <div className="kv"><span>Valor por hora</span><span>R$ {employee.valorHora || '—'}</span></div>
      </div>
      <div className="card">
        <h2>Minha assinatura</h2>
        {signature ? (
          <>
            <div style={{ border: '1px solid var(--line)', borderRadius: 8, background: '#fff', padding: 8, display: 'inline-block' }}>
              <img src={signature.imagemUrl} style={{ maxWidth: 220, maxHeight: 100 }} />
            </div>
            <p className="muted" style={{ marginTop: 8 }}>Cadastrada em {new Date(signature.criadaEm).toLocaleString('pt-BR')}</p>
          </>
        ) : (
          <p className="hint">Sua assinatura será solicitada na primeira vez que você registrar algo (ponto, alimentação ou recebimento).</p>
        )}
      </div>
      <div className="card">
        <h2>Meu documento</h2>
        {documentPhoto ? (
          <p className="muted">Documento enviado em {new Date(documentPhoto.criadaEm).toLocaleString('pt-BR')}.</p>
        ) : (
          <p className="hint">A foto do seu documento (RG, CNH ou CPF) será solicitada na primeira vez que você registrar algo.</p>
        )}
      </div>
    </>
  );
}
